import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ecChatId: "",
  id: "",
  response: "",
  responseTag: "",
  timeTaken: "",
  asrTime: "",
  chatTime: "",
  probability: "",
  userInput: "",
  isRelevant: false,
  dialPad: "",
  session: ""
};

export const ecChatSlice = createSlice({
  name: 'ecChat',
  initialState,
  reducers: {
    setECChatId: (state, action) => {
      state.ecChatId = action.payload;
    },
    setId: (state, action) => {
      state.id = action.payload;
    },
    setResponse: (state, action) => {
      state.response = action.payload;
    },
    setResponseTag: (state, action) => {
      state.responseTag = action.payload;
    },
    setTimeTaken: (state, action) => {
      state.timeTaken = action.payload;
    },
    setAsrTime: (state, action) => {
      state.asrTime = action.payload;
    },
    setChatTime: (state, action) => {
      state.chatTime = action.payload;
    },
    setProbability: (state, action) => {
      state.probability = action.payload;
    },
    setUserInput: (state, action) => {
      state.userInput = action.payload;
    },
    setIsRelevant: (state, action) => {
      state.isRelevant = action.payload;
    },
    setDialPad: (state, action) => {
      state.dialPad = action.payload;
    },
    setSession: (state, action) => {
      state.isRelevant = action.payload;
    },
    resetSession: (state) => {
      state.session = "";
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setECChatId,
  setId,
  setResponse,
  setResponseTag,
  setTimeTaken,
  setAsrTime,
  setChatTime,
  setProbability,
  setUserInput,
  setIsRelevant,
  setDialPad,
  setSession,
  resetSession
} = ecChatSlice.actions;

export default ecChatSlice.reducer;
